import { HTMLAttributes } from 'react';
import cn from 'classnames';
import { PropsWithTestId } from '../../../../../../../types';
import { HTMLtoJSX } from '../../../../../../../helpers';
import { useRootSelector } from '../../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../../store/features/pageConfig';
import style from './TestimonialQuote.module.scss';

export interface TestimonialQuoteProps extends HTMLAttributes<HTMLElement> {
  text: string;
}

export const TestimonialQuote = (
  props: PropsWithTestId<TestimonialQuoteProps>,
) => {
  const { className, testId, text, ...restProps } = props;

  const { location } = useRootSelector(selectPageConfig);

  return (
    <div
      {...restProps}
      data-testid={testId}
      className={cn(style.paragraph, className)}
    >
      {HTMLtoJSX(text, location)}
    </div>
  );
};

TestimonialQuote.defaultProps = {
  testId: 'testimonial-quote',
};
